import React from "react";

import AppRouteGenerator from "components/Common/AppRouteGenerator";

import FHIRConverter from "./FHIRConverter/Home";
import Icd from "./ICD";
import InformationGuide from "./InformationGuide";
import MetaIQ from "./MetaIQ";
import NPIRegistryHome from "./NPIRegistry";
import ReferenceSource from "./ReferenceSource";
import RxNorm from "./RxNorm";

const ReferenceData = ({ features }) => {
  const CLIENT_ROUTES = {
    "Reference Sources": {
      component: ReferenceSource,
      path: "reference-sources/*",
    },
    "ICD 10": {
      component: Icd,
      path: "icd",
    },
    RxNorm: {
      component: RxNorm,
      path: "rxnorm",
    },
    NPI: {
      component: NPIRegistryHome,
      path: "npi-registry/*",
    },
    "Meta IQ": {
      component: MetaIQ,
      path: "meta-iq/*",
    },
    "FHIR Converter": {
      component: FHIRConverter,
      path: "fhir-converter",
    },
    "FHIR Information Guide": {
      component: InformationGuide,
      path: "fhir-information-guide/*",
    },
  };

  return (
    <AppRouteGenerator CLIENT_ROUTES={CLIENT_ROUTES} features={features} />
  );
};

export default ReferenceData;
